import { render, staticRenderFns } from "./ServicePolicy.vue?vue&type=template&id=38034bad&scoped=true"
import script from "./ServicePolicy.vue?vue&type=script&lang=js"
export * from "./ServicePolicy.vue?vue&type=script&lang=js"
import style0 from "./ServicePolicy.vue?vue&type=style&index=0&id=38034bad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8432db7643500554ffee61cb980ae8ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38034bad",
  null
  
)

export default component.exports